<template>
    <div class="lni-c-form-control"
        :class="{
            'lni-c-form-control--required': required,
            'lni-c-form-control--inline': inline,
            'lni-c-form-control--custom-width': customWidth
        }"
    >
        <label class="lni-c-form-control__label":for="controlId">{{ labelText }}</label>
        <slot />
        <input
            class="lni-c-form-control__input"
            type="email"
            :value="value"
            :id="controlId"
            :name="controlId"
            :required="required"
            :maxlength="maxlength"
            @change="handleErrorState"
            @input="onInput"
        >
    </div>
</template>

<script>
import framework from '../../framework';

/**
*  The x-input-email component.
*  @module components/x-input-email
*/


/**
* The x-input-text is a basic email input control with a label.
* It can also display validation messages.
*/
export default {
    name: 'x-input-email',
    props: {
        dataLabelText: {
            type: String,
        },
    },
    mixins: [
        framework.mixins.abstractSingleValueInput,
    ],
    mounted() {
        this.initialize();
    },
    computed: {
        /**
        * The text for the label.
        * @returns {string} label text.
        */
        labelText() {
            return this.getAttribute('labelText', '');
        },
    },
    methods: {
        /**
        * Handles the input event and sets the changed value onto the component's model.
        * @param {*} event the input event
        * @returns {void}
        */
        onInput(event) {
            this.value = event.target.value;
        },
        /**
        * Gets the error information off of the input element(s)
        * @returns {void}
        */
        getErrorStateOffInputs() {
            return this.getSimpleErrorStateOffInputs('input');
        },
        /**
         * Put the values onto the Html Inputs
         * @returns {void}
         */
        initializeHtmlInputs() {
            if (this.componentValue) {
                let el = this.$el.querySelector(`input`);
                el.value = this.componentValue;
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import
"../../styles/settings",
"../x-input-text/input-text";
</style>



// WEBPACK FOOTER //
// source/components/x-input-email/x-input-email.vue